import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeader from "../components/ui/SectionHeader";
import { services } from "../data/siteData";
import { fetchSiteContent } from "../services/publicApi";

function ServicesPage() {
  const [items, setItems] = useState(services);

  useEffect(() => {
    let mounted = true;

    async function loadServices() {
      try {
        const response = await fetchSiteContent();
        if (!mounted) return;
        setItems(response?.services?.length ? response.services : services);
      } catch (error) {
        if (!mounted) return;
        setItems(services);
      }
    }

    loadServices();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Služby" title="Elektroinstalace pro domy, byty a firmy">

        </SectionHeader>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {items.map((service) => (
            <article key={service.title} className="card p-6">
              <h2 className="text-xl font-bold text-white">{service.title}</h2>
              <p className="mt-3 text-sm leading-6 text-slate-300">{service.description}</p>
              <div className="mt-5 flex items-center justify-between border-t border-cyan-300/10 pt-4">
                <span className="text-sm text-slate-400">Orientacne</span>
                <span className="text-sm font-semibold text-cyan-300">{service.price}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-cyan-300/15 bg-[#07131d] p-6 text-white sm:flex sm:items-center sm:justify-between sm:gap-6">
          <div>
            <h2 className="text-xl font-bold">Potřebujete nacenit konkretní práci?</h2>
            <p className="mt-2 text-sm leading-6 text-slate-300">Pošlete popis a ozvu se s dalším postupem.</p>
          </div>
          <Link to="/kontakt" className="mt-5 btn-primary sm:mt-0">
            Kontaktovat
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ServicesPage;
